// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var InsuranceStatus;
(function (InsuranceStatus) {
    InsuranceStatus["STATUS_UNKNOWN"] = "STATUS_UNKNOWN";
    InsuranceStatus["STATUS_ACTIVE"] = "STATUS_ACTIVE";
    InsuranceStatus["STATUS_INACTIVE"] = "STATUS_INACTIVE";
    InsuranceStatus["STATUS_SELF_PAY"] = "STATUS_SELF_PAY";
    InsuranceStatus["STATUS_INCOMPLETE"] = "STATUS_INCOMPLETE";
    InsuranceStatus["STATUS_INVESTIGATE"] = "STATUS_INVESTIGATE";
    InsuranceStatus["STATUS_ERROR"] = "STATUS_ERROR";
    InsuranceStatus["STATUS_VERIFIED"] = "STATUS_VERIFIED";
})(InsuranceStatus || (InsuranceStatus = {}));
export var InsuranceStatus_index;
(function (InsuranceStatus_index) {
    InsuranceStatus_index[InsuranceStatus_index["STATUS_UNKNOWN"] = 0] = "STATUS_UNKNOWN";
    InsuranceStatus_index[InsuranceStatus_index["STATUS_ACTIVE"] = 1] = "STATUS_ACTIVE";
    InsuranceStatus_index[InsuranceStatus_index["STATUS_INACTIVE"] = 2] = "STATUS_INACTIVE";
    InsuranceStatus_index[InsuranceStatus_index["STATUS_SELF_PAY"] = 3] = "STATUS_SELF_PAY";
    InsuranceStatus_index[InsuranceStatus_index["STATUS_INCOMPLETE"] = 4] = "STATUS_INCOMPLETE";
    InsuranceStatus_index[InsuranceStatus_index["STATUS_INVESTIGATE"] = 5] = "STATUS_INVESTIGATE";
    InsuranceStatus_index[InsuranceStatus_index["STATUS_ERROR"] = 6] = "STATUS_ERROR";
    InsuranceStatus_index[InsuranceStatus_index["STATUS_VERIFIED"] = 7] = "STATUS_VERIFIED";
})(InsuranceStatus_index || (InsuranceStatus_index = {}));
export var EligibilityType;
(function (EligibilityType) {
    EligibilityType["LITE"] = "LITE";
    EligibilityType["ENHANCED"] = "ENHANCED";
})(EligibilityType || (EligibilityType = {}));
export var EligibilityType_index;
(function (EligibilityType_index) {
    EligibilityType_index[EligibilityType_index["LITE"] = 0] = "LITE";
    EligibilityType_index[EligibilityType_index["ENHANCED"] = 1] = "ENHANCED";
})(EligibilityType_index || (EligibilityType_index = {}));
export var InsuranceVerificationStatus;
(function (InsuranceVerificationStatus) {
    InsuranceVerificationStatus["NOT_INITIATED"] = "NOT_INITIATED";
    InsuranceVerificationStatus["IN_PROGRESS"] = "IN_PROGRESS";
    InsuranceVerificationStatus["COMPLETED"] = "COMPLETED";
    InsuranceVerificationStatus["FAILED"] = "FAILED";
})(InsuranceVerificationStatus || (InsuranceVerificationStatus = {}));
export var InsuranceVerificationStatus_index;
(function (InsuranceVerificationStatus_index) {
    InsuranceVerificationStatus_index[InsuranceVerificationStatus_index["NOT_INITIATED"] = 0] = "NOT_INITIATED";
    InsuranceVerificationStatus_index[InsuranceVerificationStatus_index["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    InsuranceVerificationStatus_index[InsuranceVerificationStatus_index["COMPLETED"] = 2] = "COMPLETED";
    InsuranceVerificationStatus_index[InsuranceVerificationStatus_index["FAILED"] = 3] = "FAILED";
})(InsuranceVerificationStatus_index || (InsuranceVerificationStatus_index = {}));
export var EventType;
(function (EventType) {
    EventType["EVENT_TYPE_ELIGIBILITY_OK"] = "EVENT_TYPE_ELIGIBILITY_OK";
    EventType["EVENT_TYPE_ELIGIBILITY_UPDATED"] = "EVENT_TYPE_ELIGIBILITY_UPDATED";
    EventType["EVENT_TYPE_ELIGIBILITY_FAILED"] = "EVENT_TYPE_ELIGIBILITY_FAILED";
})(EventType || (EventType = {}));
export var EventType_index;
(function (EventType_index) {
    EventType_index[EventType_index["EVENT_TYPE_ELIGIBILITY_OK"] = 0] = "EVENT_TYPE_ELIGIBILITY_OK";
    EventType_index[EventType_index["EVENT_TYPE_ELIGIBILITY_UPDATED"] = 1] = "EVENT_TYPE_ELIGIBILITY_UPDATED";
    EventType_index[EventType_index["EVENT_TYPE_ELIGIBILITY_FAILED"] = 2] = "EVENT_TYPE_ELIGIBILITY_FAILED";
})(EventType_index || (EventType_index = {}));
export var ReportingType;
(function (ReportingType) {
    ReportingType["REPORTING_TYPE_INSURANCE_ELIGIBILITY"] = "REPORTING_TYPE_INSURANCE_ELIGIBILITY";
    ReportingType["REPORTING_TYPE_PARTNER_REQUESTS_LOG"] = "REPORTING_TYPE_PARTNER_REQUESTS_LOG";
})(ReportingType || (ReportingType = {}));
export var ReportingType_index;
(function (ReportingType_index) {
    ReportingType_index[ReportingType_index["REPORTING_TYPE_INSURANCE_ELIGIBILITY"] = 0] = "REPORTING_TYPE_INSURANCE_ELIGIBILITY";
    ReportingType_index[ReportingType_index["REPORTING_TYPE_PARTNER_REQUESTS_LOG"] = 1] = "REPORTING_TYPE_PARTNER_REQUESTS_LOG";
})(ReportingType_index || (ReportingType_index = {}));
